import type { IPermissionModel } from 'models/auth/entities/PermissionModel';
import React, { createContext, useContext, ReactNode, useState, useEffect } from 'react';
import { isOwnPermissionsListResponseModel } from 'stores/administrator/AdministratorTypeGuard';
import authStore from 'stores/auth/AuthStore';

interface AuthContextType {
    permissions: IPermissionModel[] | null;
    hasPermission: (key: string) => boolean;
    isColumnVisible: (key: string) => boolean;
    hasPermissionList: (key: string[]) => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [permissions, setPermissions] = useState<IPermissionModel[] | null>(null);

    useEffect(() => {
        

        const fetchPermissions = async () => {
            const response = await authStore.getOwnPermissionList();
            if (isOwnPermissionsListResponseModel(response))
                setPermissions(response);
        };
        fetchPermissions();
    }, []);

    const hasPermission = (key: string) => permissions?.some(auth => auth.codename === key) ?? false;
    const isColumnVisible = (permissionKey: string): boolean => hasPermission(permissionKey);

    const hasPermissionList = (keys: string | string[]) => {
        const keysArray = Array.isArray(keys) ? keys : [keys];

        return keysArray.some(codename =>
            permissions?.some(auth => auth.codename === codename)
        );
    };

    // Caso as permissões ainda estejam sendo carregadas, retornamos `null`
    if (!permissions) return null;

    return (
        <AuthContext.Provider value={{ permissions, hasPermission, isColumnVisible, hasPermissionList }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};